import React, {Component} from "react";
import ChangeIcon from "./ChangeIcon";

class ChangeIconClass extends Component {
    constructor(props) {
        super(props);
        this.state = { src : props.src }
        this.onChange = this.onChange.bind(this);
    }
    onChange = (event) => {
        if (event.target.files[0]) {
            const _file = event.target.files[0];

            this.props.onChangeFile(_file);
            this.setState({src : URL.createObjectURL(_file)});
        }
    }

    render() { 
        const {src} = this.state;
        return ( 
            <ChangeIcon src={src} onChange={this.onChange} />
         );
    }
}
 
export default ChangeIconClass;